var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiamondPath(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "8px",
    viewBox: "0 0 31 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DiamondPath") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DiamondPath",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2513704,3 C29.8036552,3 30.2513704,3.44771525 30.2513704,4 C30.2513704,4.51283584 29.8653302,4.93550716 29.3679916,4.99327227 L29.2513704,5 L1,5 C0.44771525,5 5.68434189e-14,4.55228475 5.68434189e-14,4 C5.68434189e-14,3.48716416 0.38604019,3.06449284 0.883378875,3.00672773 L1,3 L29.2513704,3 Z",
    id: "Path",
    fillOpacity: 0.599978147,
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3060194,3.26120387 L14.2612039,0.306019375 C14.6692297,-0.102006458 15.3307703,-0.102006458 15.7387961,0.306019375 L18.6939806,3.26120387 C19.1020065,3.66922971 19.1020065,4.33077029 18.6939806,4.73879613 L15.7387961,7.69398063 C15.3307703,8.10200646 14.6692297,8.10200646 14.2612039,7.69398063 L11.3060194,4.73879613 C10.8979935,4.33077029 10.8979935,3.66922971 11.3060194,3.26120387 Z",
    id: "Diamond",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondPath);
export default __webpack_public_path__ + "static/media/DiamondPath.c6e1610a2d272e40faa015e4e3304080.svg";
export { ForwardRef as ReactComponent };